<template>
    <div class="font-xs">
        <span class="text-secondary">By continuing, you agree to Home Credit's </span>
        <a :id="termsAndConditionId" class="text-success clickable" href="https://www.homecredit.ph/disclosures">Terms &<br />Conditions</a>
    </div>
</template>
<script>
export default {
    props:['termsAndConditionId']
}
</script>